export default __webpack_public_path__ + "static/heels4.inspirations-2d841714842bc0d6bbd403d62f4143a7.jpg";